import { useRef } from "react";
import { Html } from "@react-three/drei";
import imageSpotIcon from "../../static/images/image-spot.png";
function InfoImageSpot({
	imageSpot,
	selectObject,
	transformControl,
	isPreviewComponent,
	setIsInfoImageSpotOpen,
	setInfoImageSpotDetails,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsInfoImageSpotOpen(true);
			setInfoImageSpotDetails({
				url: imageSpot.url,
				text: imageSpot.text,
			});
		} else {
			selectObject(imageSpot, mesh.current);
		}
	};
	return (
		<mesh ref={mesh} position={imageSpot.position}>
			<Html center zIndexRange={[100, 10]}>
				<img
					className="infoImagespot"
					src={imageSpotIcon}
					alt="info spot"
					width="35px"
					height="35px"
					onClick={(e) => {
						onClickHandler();
					}}
				/>
			</Html>
		</mesh>
	);
}
export default InfoImageSpot;
